import { Validation, ValidationRankings, ValidationState, ValidatorType } from '@vp/upload-and-print-validator';
import { PageDimensionValidationType } from 'src/providers/ValidationContextProvider';

/**
 * Checks if the provided error data indicates a cover page error.
 *
 * A cover page error is detected when there are errors on pages up to and including page 2,
 * but no errors on pages greater than 2.
 *
 * @param errorData - An array of error objects, where each object has a `page` property indicating the page number.
 * @returns `true` if a cover page error is detected, `false` otherwise.
 */
const checkIsCoverPageError = (errorData: Array<PageDimensionValidationType>) => {
  if (errorData.length <= 2) {
    return errorData.some(error => error.page <= 2);
  }
  return false;
};

const getTemplateMismatchValidation = (pageSizeValidation: Validation) => {
  const isErrorState = pageSizeValidation.details ? checkIsCoverPageError(pageSizeValidation.details?.errors) : false;
  return {
    rank: ValidationRankings.TemplateMismatchValidatorRank,
    id: ValidatorType.TemplateMismatchValidator,
    state: isErrorState ? ValidationState.Error : pageSizeValidation.state,
    message: isErrorState ? `validations.${ValidatorType.TemplateMismatchValidator}.message` : '',
    title: `validations.${ValidatorType.TemplateMismatchValidator}.title`,
  };
};

/**
 * Adds a template mismatch validation to the provided list of validations if perfect bound.
 */
export const addTemplateMismatchValidationIfNeeded = (
  validationList: Array<Validation>,
  isPerfectBound: boolean
): Array<Validation> => {
  if (isPerfectBound) {
    const pageSizeValidation = validationList.find(v => v.id === ValidatorType.PageSizeValidator);
    if (pageSizeValidation) {
      const templateMismatchValidation = getTemplateMismatchValidation(pageSizeValidation);
      validationList.push(templateMismatchValidation);
    }
  }
  return validationList;
};
